module.exports = __webpack_public_path__ + "img/yonghu2.bbdbac8b.png";